import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ConfirmationModal } from "@/components/shared/confirmation.modal";
import { Trash2 } from "lucide-react";

type PickUpLocationProps = {
  isDefault: boolean;
  name: string;
  deletePickUpLocation: () => void;
  updatePickUpLocation: () => void;
};

export const PickUpLocationElem = ({
  isDefault,
  name,
  deletePickUpLocation,
  updatePickUpLocation,
}: PickUpLocationProps) => {
  const { t } = useTranslation("boClients");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <div className="flex flex-row justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
        <div className="flex flex-1 flex-col">
          <p className="text-xs font-medium text-gray-500">
            {isDefault
              ? t("profilePickUpLocationElem.defaultLocation")
              : t("profilePickUpLocationElem.additionalLocation")}
          </p>
          <p className="text-sm font-medium text-gray-900">{name}</p>
        </div>
        <div className="flex flex-row items-center gap-2">
          <Button onClick={updatePickUpLocation} variant="outline">
            {t("profilePickUpLocationElem.edit")}
          </Button>
          {!isDefault && (
            <Button onClick={() => setIsDeleteModalOpen(true)} variant="destructive">
              <Trash2 />
            </Button>
          )}
        </div>
      </div>
      <ConfirmationModal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title={t("profilePickUpLocationElem.deleteTitle")}
        text={t("profilePickUpLocationElem.deleteDescription", { name })}
        confirm={deletePickUpLocation}
      />
    </>
  );
};
